import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import Skeleton from '@yisheng90/react-loading';
import '../../css/loading.css';

class Loading extends React.Component{
    render(){
        return(
            <Container className="loading">
                <Row>
                    <Col md={6} className="gambar">
                        <Skeleton />
                    </Col>
                    <Col className="p-4">
                        <Skeleton height="50px" className="mb-3"/>
                        <Skeleton height="25px" width="70%" className="mb-5"/>
                        
                        <Skeleton height="25px" width="30%" className="mb-3"/>
                        <Skeleton height="40px" className="mb-4"/>

                        <Skeleton height="25px" width="30%" className="mb-3"/>
                        <Skeleton height="40px" className="mb-5"/>

                        <Skeleton height="50px" width="40%" className="mb-3"/>
                    </Col >
                </Row>
                <Row>
                    <Col className="p-4">
                        <Skeleton height="20px" width="90%" className="mb-3 ml-auto"/>
                        <Skeleton height="20px" className="mb-3"/>
                        <Skeleton height="20px" className="mb-3"/>
                        <Skeleton height="20px" width="80%" className="mb-3 "/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

class LoadingImage extends React.Component{
    render(){
        return(
            <div className="gambar">
                <Skeleton />
            </div>
        );
    }
}

export {LoadingImage, Loading,};